import React from "react"
import Video from "../video"

const Intro = ({featureImage, className, title, summary, role}) => {

  return (
      <div className="contained">
        <div className="project-heading">
            <div>
              <Video src={featureImage} className={className} autoPlay={true}/>
            </div>
            <div className="project-details">
              <h2>{title}</h2>
              <h3>Summary</h3>
              <p className="meta">{summary}</p>
              <h3 className="top2">Role</h3>
              <p className="meta">{role}</p>
            </div>
        </div>
      </div>
  );
}

Intro.defaultProps = {
  mediaSRC:``,
  title:``,
  summary:``,
  role:``
}


export default Intro
